import { Box, BoxProps, Image, Text } from '@jfs/ui-new'
import { FC } from 'react'
import useFontSize from '../../../util/useFontSize'
import usePadding from '../../../util/usePadding'
import { isMobileWidth, isTabletWidth, useWindowDimensions } from '../../../util/util'

interface SectionListProps {
  data: any
}

const SectionList: FC<SectionListProps> = ({ data }: SectionListProps) => {
  const { headerSize, headerLineHeight } = useFontSize()
  const viewPortWidth = useWindowDimensions()
  const isMobile = isMobileWidth(viewPortWidth)
  const isTab = isTabletWidth(viewPortWidth)
  const resPadding = usePadding()
  const themedStyle = styles(viewPortWidth, resPadding)
  return (
    <Box pv={isTab ? 35 : 0}>
      {data?.map((item: any, index: number) => {
        const imageHasFullBg = item?.coloredBgImage ?? false
        const isRight = index % 2 === 0
        return (
          <Box {...themedStyle.container} flexDirection={isRight ? 'row-reverse' : 'row'}>
            <Box {...themedStyle.boxContainer(imageHasFullBg, isTab)}>
              <Text
                fontSize={headerSize}
                fontFamily="jiotype-black"
                lineHeight={isMobile || isTab ? headerLineHeight + 4 : headerLineHeight}>
                {item.header}
              </Text>
              <Box w={isMobile || isTab ? '100%' : '80%'} pt={isMobile || isTab ? 10 : 26}>
                <Text
                  fontFamily="jiotype-medium"
                  fontSize={isMobile || isTab ? 'FONT_SIZE_MEDIUM' : 'MEDIUM'}
                  color="BRAND_COLOR_GRAY_1"
                  lineHeight={isMobile || isTab ? 22 : 32}>
                  {item.subheader}
                </Text>
              </Box>
            </Box>
            <Box
              {...themedStyle.imageContainer(imageHasFullBg, isTab)}
              alignItems={isRight ? 'flex-start' : 'flex-end'}>
              <Image
                source={item.image}
                resizeMode="contain"
                height="100%"
                width={isTab ? '100%' : isMobile ? '100%' : isRight ? '90%' : imageHasFullBg ? '100%' : '90%'}
              />
            </Box>
          </Box>
        )
      })}
    </Box>
  )
}

const styles = (breakpoint: number, responsivePadding: number) => {
  // const responsivePadding = getPadding(breakpoint)
  const isMobile = isMobileWidth(breakpoint)
  const istablet = isTabletWidth(breakpoint)
  return {
    container: {
      display: 'flex',
      paddingVertical: isMobile || istablet ? 10 : 20,
      minHeight: istablet ? 300 : 420,
      marginVertical: breakpoint > 600 ? 0 : 12,
      flexWrap: 'wrap-reverse',
      paddingHorizontal: responsivePadding,
      pt: isMobile ? 90 : undefined,
      justifyContent: 'space-between',
      // borderWidth: 1,
      // alignItems:'center',
    } as BoxProps,
    imageContainer: (imageHasFullBg: boolean, isTab: boolean) =>
      ({
        display: 'flex',
        // flex: 1,
        width: isTab ? '48%' : breakpoint > 600 ? '50%' : '100%',
        justifyContent: 'center',
        minHeight: isMobile ? (imageHasFullBg ? 250 : 220) : isTab ? 350 : imageHasFullBg ? 440 : 400,
        minWidth: breakpoint > 600 ? 300 : '100%',
      } as BoxProps),
    boxContainer: (imageHasFullBg: boolean, isTab: boolean) =>
      ({
        display: 'flex',
        pt: isMobile ? (imageHasFullBg ? 40 : 10) : 20,
        flexDirection: 'column',
        width: isTab ? '45%' : breakpoint > 600 ? '50%' : '100%',
        justifyContent: 'center',
      } as BoxProps),
  }
}
export default SectionList
